<!-- <section id="hero" class="d-flex align-items-center">

  <div class="container-fluid">
    <div class="row"> -->
      <!-- <div class="col-lg-6 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-2 order-lg-1" data-aos="fade-up" data-aos-delay="200">
        <h1>It all starts with a digital business card</h1>
        <h2>My DVC is a trail free end-to-end contact manager designed to help you curate and grow your professional relationships.</h2>
        <div class="d-flex justify-content-center justify-content-lg-start">
          <a href="/login" class="btn-get-started scrollto">Get Started</a>
          <a href="https://www.youtube.com/watch?v=jDDaplaOz7Q" class="glightbox btn-watch-video"><i class="bi bi-play-circle"></i><span>Watch Video</span></a>
        </div>
      </div>
      <div class="col-lg-6 order-1 order-lg-2 hero-img" data-aos="zoom-in" data-aos-delay="200">
        <img src="assets/img/hero-img.png" class="img-fluid animated" alt="">
      </div> -->
      <!-- <video autoPlay muted loop id="myVideo">
        <source
          src="../../assets/videos/header1.mp4"
          type="video/mp4"
        />
      </video> -->
      <!-- <div class="content1">
        <h1>It all starts with a digital business card</h1>
        <h2>My DVC is a trail free end-to-end contact manager designed to help you curate and grow your professional relationships.</h2>
        <div class="d-flex justify-content-center justify-content-lg-start">
          <a href="/login" class="btn-get-started scrollto">Get Started</a>
          </div>
      </div> -->
    <!-- </div>
  </div>

</section> -->
<app-video-tile></app-video-tile>
<main id="main">
  <app-topnav></app-topnav>

  <app-header-tile></app-header-tile>
  <!-- ======= Boring Printed Business Cards Section ======= -->
  <section style="margin-top: 300px;" id="boring" class="about">
    <div class="container" data-aos="fade-up">

      <div class="section-title">
        <h2 >Boring Printed Business Cards</h2>
      </div>

      <div class="row content">
        <div class="col-lg-6">
          <p>
            We are providing user friendly interface for card creation, by using this user can easily create their own business card.
          </p>
          <ul>
            <li><i class="ri-check-double-line"></i> Create DVC </li>
            <li><i class="ri-check-double-line"></i> Pay for convenient Period </li>
            <li><i class="ri-check-double-line"></i> For Business </li>
          </ul>
        </div>
        <div class="col-lg-6 pt-4 pt-lg-0">
          <p>
            We are providing full access for the 14 days trail period, if you are impressed by us, if you want to increase the period of your business card you can easily increase the availability of your card.
            We are also welcomes you for being an agent in between Us & Customers.
          </p>
        </div>
      </div>

    </div>
  </section>


  <section id="why-us" class="why-us section-bg">
    <div class="container-fluid" data-aos="fade-up">

      <div class="row">

        <div class="col-lg-7 d-flex flex-column justify-content-center align-items-stretch  order-2 order-lg-1">

          <div class="accordion-list">
            <ul>
              <li>
                <a data-bs-toggle="collapse" class="collapse" data-bs-target="#accordion-list-1"><span>01</span> How does My DVC Work? <i class="bx bx-chevron-down icon-show"></i><i class="bx bx-chevron-up icon-close"></i></a>
                <div id="accordion-list-1" class="collapse show" data-bs-parent=".accordion-list">
                  <p>
                    My DVC's digital business cards are Rich and Customizable. After you sign upon the web, you'll be able to create and personalize your first virtual business card. you can create as many business cards as you'd like, with different information on each card. Make a card for your work contacts, for clients or customers and friends.
                  </p>
                </div>
              </li>

              <li>
                <a data-bs-toggle="collapse" data-bs-target="#accordion-list-2" class="collapsed"><span>02</span> Customize your cards <i class="bx bx-chevron-down icon-show"></i><i class="bx bx-chevron-up icon-close"></i></a>
                <div id="accordion-list-2" class="collapse" data-bs-parent=".accordion-list">
                  <p>
                    My DVC goes beyond the basic contact information you see on other business card apps. Include your preferred name, pronouns, and any accreditations, on your digital business card. Add a picture of yourself so people remember who you are to bring your card to Life. Include your social media accounts, a company logo, your gpay, whatsapp and more-</p>
                </div>
              </li>

              <li>
                <a data-bs-toggle="collapse" data-bs-target="#accordion-list-3" class="collapsed"><span>03</span>Securities <i class="bx bx-chevron-down icon-show"></i><i class="bx bx-chevron-up icon-close"></i></a>
                <div id="accordion-list-3" class="collapse" data-bs-parent=".accordion-list">
                  <p>
                    We don't misuse your details provided in the Business card, and we are using SSL certified server so your details will be End-End encrypted. and providing more securities compare than others.

Business Contact</p>
                </div>
              </li>

            </ul>
          </div>

        </div>

        <div class="col-lg-5 align-items-stretch order-1 order-lg-2 img" style='background-image: url("assets/img/why-us.png");' data-aos="zoom-in" data-aos-delay="150">&nbsp;</div>
      </div>

    </div>
  </section>

   <section id="samplecards" class="portfolio">
    <div class="container" data-aos="fade-up">

      <div class="section-title">
        <h2>Sample Cards</h2>
        <p></p>
      </div>

      <ul id="portfolio-flters" class="d-flex justify-content-center" data-aos="fade-up" data-aos-delay="100">
        <li data-filter="*" class="filter-active">All</li>
        <li data-filter=".filter-basic">Basic</li>
        <li data-filter=".filter-prof">Professional</li>
        <li data-filter=".filter-business">Business</li>
      </ul>

      <div class="row portfolio-container" data-aos="fade-up" data-aos-delay="200">

        <div class="col-lg-4 col-md-6 portfolio-item filter-basic">

          <!-- <app-basic-theme-one></app-basic-theme-one> -->
          <!-- <div class="portfolio-img"><img src="assets/img/portfolio/portfolio-6.jpg" class="img-fluid" alt=""></div>
          <div class="portfolio-info">
            <h4>App 3</h4>
            <p>App</p>
            <a href="assets/img/portfolio/portfolio-6.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox preview-link" title="App 3"><i class="bx bx-plus"></i></a>
            <a href="portfolio-details.html" class="details-link" title="More Details"><i class="bx bx-link"></i></a>
          </div> -->
        </div>


        <div class="col-lg-4 col-md-6 portfolio-item filter-prof">
          <!-- <div class="portfolio-img"><img src="assets/img/portfolio/portfolio-9.jpg" class="img-fluid" alt=""></div>
          <div class="portfolio-info">
            <h4>Web 3</h4>
            <p>Web</p>
            <a href="assets/img/portfolio/portfolio-9.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox preview-link" title="Web 3"><i class="bx bx-plus"></i></a>
            <a href="portfolio-details.html" class="details-link" title="More Details"><i class="bx bx-link"></i></a>
          </div> -->
        </div>


        <div class="col-lg-4 col-md-6 portfolio-item filter-business">
          <!-- <div class="portfolio-img"><img src="assets/img/portfolio/portfolio-8.jpg" class="img-fluid" alt=""></div>
          <div class="portfolio-info">
            <h4>Card 3</h4>
            <p>Card</p>
            <a href="assets/img/portfolio/portfolio-8.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox preview-link" title="Card 3"><i class="bx bx-plus"></i></a>
            <a href="portfolio-details.html" class="details-link" title="More Details"><i class="bx bx-link"></i></a>
          </div> -->
        </div>
      </div>

    </div>
  </section>

  <section id="pricing" class="pricing">
  <div class="container" data-aos="fade-up">

    <div class="section-title">
      <h2>Pricing</h2>
      </div>

    <div class="row">

      <div class="col-lg-4" data-aos="fade-up" data-aos-delay="100">
        <div class="box">
          <h3>Basic Plan</h3>
          <h4><sup>Rs</sup>299<span>per year</span></h4>
          <ul>
            <li><i class="bx bx-check"></i> Basic Details</li>
            <li><i class="bx bx-check"></i> Social Media Integration</li>
            <li><i class="bx bx-check"></i> Payment Integration</li>
            <li><i class="bx bx-check"></i> 10 Gallery Images</li>
            <li><i class="bx bx-check"></i> Products List</li>
            <li class="na"><i class="bx bx-x"></i> <span>Enquiry Forms</span></li>
          </ul>
          <a href="/login" class="buy-btn">Get Started</a>
        </div>
      </div>

      <div class="col-lg-4 mt-4 mt-lg-0" data-aos="fade-up" data-aos-delay="200">
        <div class="box featured">
          <h3>Professional Plan</h3>
          <h4><sup>Rs</sup>499<span>per year</span></h4>
          <ul>
            <li><i class="bx bx-check"></i> Basic Details</li>
            <li><i class="bx bx-check"></i> Social Media Integration</li>
            <li><i class="bx bx-check"></i> Payment Integration</li>
            <li><i class="bx bx-check"></i> 25 Gallery Images</li>
            <li><i class="bx bx-check"></i> Products/Service Attachments</li>
            <li><i class="bx bx-check"></i> About Us </li>
            <li><i class="bx bx-check"></i> Enquiry Forms</li>


          </ul>
          <a href="/login" class="buy-btn">Get Started</a>
        </div>
      </div>

      <div class="col-lg-4 mt-4 mt-lg-0" data-aos="fade-up" data-aos-delay="300">
        <div class="box">
          <h3>Business Plan</h3>
          <h4><sup>Rs</sup>699<span>per year</span></h4>
          <ul>
            <li><i class="bx bx-check"></i> Basic Details</li>
            <li><i class="bx bx-check"></i> Social Media Integration</li>
            <li><i class="bx bx-check"></i> Payment Integration</li>
            <li><i class="bx bx-check"></i> 50 Gallery Images</li>
            <li><i class="bx bx-check"></i> Products/Service Attachments</li>
            <li><i class="bx bx-check"></i> About Us </li>
            <li><i class="bx bx-check"></i> Enquiry Forms</li>
          </ul>
          <a href="/login" class="buy-btn">Get Started</a>
        </div>
      </div>

    </div>

  </div>
</section>

<section id="forbusiness" class="d-flex align-items-center">

  <div class="container">
    <div class="row">
      <div class="col-lg-6 order-1 order-lg-2 hero-img" data-aos="zoom-in" data-aos-delay="200">
        <img src="assets/img/hero-img.png" class="img-fluid animated" alt="">
      </div>
      <div class="col-lg-6 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-2 order-lg-1" data-aos="fade-up" data-aos-delay="200">
        <h1>Benefits of Being an Agent with My DVC</h1>
        <h2>My DVC providing business relationship between you and end users, based on the referal code used by the customers card, my dvc providing certain percentage of amount
          to the agent in every 15th of the month. you are not providing any money to the organization for being an agent but it will be benefit for your work with My DVC.
        </h2>
        <div class="d-flex justify-content-center justify-content-lg-start">
          <a href="/beingagent" class="btn-get-started scrollto">Get Started</a>
          <!-- <a href="https://www.youtube.com/watch?v=jDDaplaOz7Q" class="glightbox btn-watch-video"><i class="bi bi-play-circle"></i><span>Watch Video</span></a> -->
        </div>
      </div>

    </div>
  </div>

</section>

  </main>
  <!-- ======= Footer ======= -->
  <footer id="footer">

    <div class="footer-newsletter">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <h4>Join Our Newsletter</h4>
            <form action="" method="post">
              <input type="email" [(ngModel)]='subscribe.email' #email name="email" id="email" required><input type="submit" (click)="onSubscribe()" value="Subscribe">
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-top">
      <div class="container">
        <div class="row">

          <div class="col-lg-3 col-md-6 footer-contact">
            <h3>My DVC</h3>
            <p>
              Addresss <br>
              Salem<br>
              Tamil Nadu <br><br>
              <strong>Phone:</strong> +91 7708047141<br>
              <strong>Email:</strong> info@mydvc.com<br>
            </p>
          </div>

          <div class="col-lg-3 col-md-6 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><i class="bx bx-chevron-right"></i> <a href="#">Home</a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="/signup">Sign Up</a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="/login">Login</a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="/tos">Terms of service</a></li>
              <li><i class="bx bx-chevron-right"></i> <a href="/pp">Privacy policy</a></li>
            </ul>
          </div>

          <div class="col-lg-3 col-md-6 footer-links">
            <h4>Our Social Networks</h4>
            <div class="social-links mt-3">
              <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>
              <a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>
              <a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="container footer-bottom clearfix">
      <div class="copyright">
        &copy; Copyright <strong><span>My DVC</span></strong>. All Rights Reserved
      </div>
      <div class="credits">
        Designed by <a href="https://logixsoftwares.com/">Logix Softwares</a>
      </div>
    </div>
  </footer>
